module.exports = __webpack_public_path__ + "img/chianti.168c7464.jpg";